// extracted by mini-css-extract-plugin
export default {"wrapper":"CampusAmbassador_wrapper__tTXMe","card1":"CampusAmbassador_card1__h7ZUo","card2":"CampusAmbassador_card2__QEaTV"};